import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f727c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "wrapper-div",
  id: "wrapper-div"
}
const _hoisted_2 = {
  class: "section1-container",
  id: "scope3-section1"
}
const _hoisted_3 = { id: "main-description-text" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column invisible" }, null, -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "category-box upstream-color",
  style: {"font-size":"small"}
}
const _hoisted_8 = {
  key: 1,
  class: "category-box downstream-color",
  style: {"font-size":"small"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column invisible" }, null, -1))
const _hoisted_10 = {
  class: "section2-container",
  id: "scope3-section2"
}
const _hoisted_11 = {
  key: 0,
  class: "table results-table w-percent-100",
  "aria-describedby": "scope3-result-table-header1"
}
const _hoisted_12 = { class: "bg-primary" }
const _hoisted_13 = {
  id: "scope3-result-table-header1",
  colspan: "3",
  scope: "colgroup"
}
const _hoisted_14 = { style: {"font-weight":"600"} }
const _hoisted_15 = {
  id: "scope3-result-sub-header-1",
  headers: "scope3-result-table-header1",
  style: {"width":"53%"},
  class: "py-405"
}
const _hoisted_16 = {
  id: "scope3-result-sub-header-2",
  headers: "scope3-result-table-header1",
  style: {"width":"23%"},
  class: "py-405"
}
const _hoisted_17 = {
  id: "scope3-result-sub-header-3",
  headers: "scope3-result-table-header1",
  style: {"width":"23%"},
  class: "py-405"
}
const _hoisted_18 = { id: "category-1-table-row" }
const _hoisted_19 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"},
  class: "upstream-category-result-td"
}
const _hoisted_20 = { headers: "scope3-result-sub-header-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_22 = { id: "category-2-table-row" }
const _hoisted_23 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_24 = { headers: "scope3-result-sub-header-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_26 = { id: "category-3-table-row" }
const _hoisted_27 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_28 = { headers: "scope3-result-sub-header-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_30 = { id: "category-4-table-row" }
const _hoisted_31 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_32 = { headers: "scope3-result-sub-header-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_34 = { id: "category-5-table-row" }
const _hoisted_35 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_36 = { headers: "scope3-result-sub-header-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_38 = { id: "category-6-table-row" }
const _hoisted_39 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_40 = { headers: "scope3-result-sub-header-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_42 = { id: "category-7-table-row" }
const _hoisted_43 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_44 = { headers: "scope3-result-sub-header-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_46 = {
  id: "category-8-table-row",
  class: "border-bottom-solid-black"
}
const _hoisted_47 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_48 = { headers: "scope3-result-sub-header-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-3" }, null, -1))
const _hoisted_50 = { id: "category-9-table-row" }
const _hoisted_51 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-2" }, null, -1))
const _hoisted_53 = { headers: "scope3-result-sub-header-3" }
const _hoisted_54 = { id: "category-10-table-row" }
const _hoisted_55 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-2" }, null, -1))
const _hoisted_57 = { headers: "scope3-result-sub-header-3" }
const _hoisted_58 = { id: "category-11-table-row" }
const _hoisted_59 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-2" }, null, -1))
const _hoisted_61 = { headers: "scope3-result-sub-header-3" }
const _hoisted_62 = { id: "category-12-table-row" }
const _hoisted_63 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-2" }, null, -1))
const _hoisted_65 = { headers: "scope3-result-sub-header-3" }
const _hoisted_66 = { id: "category-13-table-row" }
const _hoisted_67 = {
  headers: "scope3-result-sub-header-1",
  style: {"text-align":"left"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { headers: "scope3-result-sub-header-2" }, null, -1))
const _hoisted_69 = { headers: "scope3-result-sub-header-3" }
const _hoisted_70 = {
  id: "total-results-table-row",
  class: "text-align-right",
  style: {"font-weight":"600"}
}
const _hoisted_71 = {
  class: "scope3-total",
  style: {"text-align":"left"}
}
const _hoisted_72 = {
  key: 0,
  class: "scope3-total"
}
const _hoisted_73 = {
  key: 1,
  class: "scope3-total"
}
const _hoisted_74 = {
  id: "grand-total-results-table-row",
  class: "text-align-right",
  style: {"font-weight":"600"}
}
const _hoisted_75 = {
  class: "scope3-total",
  style: {"text-align":"left"}
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "scope3-total" }, null, -1))
const _hoisted_77 = {
  key: 0,
  class: "scope3-total"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_Scope3ResultsColumnChart = _resolveComponent("Scope3ResultsColumnChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, [
        _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-main-header" })
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createVNode(_component_RichText, { "text-key": "results.scope3.result-main-description-text" })
      ]),
      (_ctx.filteredCategoryResults)
        ? (_openBlock(), _createBlock(_component_Scope3ResultsColumnChart, {
            key: 0,
            id: "scope3-column-chart",
            ref: "scope3ResultColumnChart",
            "raw-data": _ctx.filteredCategoryResults
          }, null, 8, ["raw-data"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_ctx.upstreamTotal)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-upstream-box-text" })
              ]))
            : _createCommentVNode("", true),
          (_ctx.downstreamTotal)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-downstream-box-text" })
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.results?.groupingResults)
        ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_12, [
                _createElementVNode("th", _hoisted_13, [
                  _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-table-header1" })
                ])
              ])
            ]),
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_14, [
                _createElementVNode("th", _hoisted_15, [
                  _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-table-header2" })
                ]),
                _createElementVNode("th", _hoisted_16, [
                  _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-table-header3" })
                ]),
                _createElementVNode("th", _hoisted_17, [
                  _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-table-header4" })
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", _hoisted_18, [
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category1" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_1'), 2)), 1)
                ]),
                _hoisted_21
              ]),
              _createElementVNode("tr", _hoisted_22, [
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category2" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_2'), 2)), 1)
                ]),
                _hoisted_25
              ]),
              _createElementVNode("tr", _hoisted_26, [
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category3" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_28, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_3'),2)), 1)
                ]),
                _hoisted_29
              ]),
              _createElementVNode("tr", _hoisted_30, [
                _createElementVNode("td", _hoisted_31, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category4" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_32, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_4'), 2)), 1)
                ]),
                _hoisted_33
              ]),
              _createElementVNode("tr", _hoisted_34, [
                _createElementVNode("td", _hoisted_35, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category5" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_36, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_5'), 2)), 1)
                ]),
                _hoisted_37
              ]),
              _createElementVNode("tr", _hoisted_38, [
                _createElementVNode("td", _hoisted_39, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category6" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_40, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_6'), 2)), 1)
                ]),
                _hoisted_41
              ]),
              _createElementVNode("tr", _hoisted_42, [
                _createElementVNode("td", _hoisted_43, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category7" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_44, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_7'), 2)), 1)
                ]),
                _hoisted_45
              ]),
              _createElementVNode("tr", _hoisted_46, [
                _createElementVNode("td", _hoisted_47, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category8" })
                  ])
                ]),
                _createElementVNode("td", _hoisted_48, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_8'), 2)), 1)
                ]),
                _hoisted_49
              ]),
              _createElementVNode("tr", _hoisted_50, [
                _createElementVNode("td", _hoisted_51, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category9" })
                  ])
                ]),
                _hoisted_52,
                _createElementVNode("td", _hoisted_53, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_9'), 2)), 1)
                ])
              ]),
              _createElementVNode("tr", _hoisted_54, [
                _createElementVNode("td", _hoisted_55, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category10" })
                  ])
                ]),
                _hoisted_56,
                _createElementVNode("td", _hoisted_57, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_10'), 2)), 1)
                ])
              ]),
              _createElementVNode("tr", _hoisted_58, [
                _createElementVNode("td", _hoisted_59, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category11" })
                  ])
                ]),
                _hoisted_60,
                _createElementVNode("td", _hoisted_61, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_11'), 2)), 1)
                ])
              ]),
              _createElementVNode("tr", _hoisted_62, [
                _createElementVNode("td", _hoisted_63, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category12" })
                  ])
                ]),
                _hoisted_64,
                _createElementVNode("td", _hoisted_65, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_12'), 2)), 1)
                ])
              ]),
              _createElementVNode("tr", _hoisted_66, [
                _createElementVNode("td", _hoisted_67, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_SimpleText, { "text-key": "calculation.dropdown.possiblevalue.unit.category13" })
                  ])
                ]),
                _hoisted_68,
                _createElementVNode("td", _hoisted_69, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.doPrettify(_ctx.displayTableResults('CATEGORY_13'), 2)), 1)
                ])
              ]),
              _createElementVNode("tr", _hoisted_70, [
                _createElementVNode("td", _hoisted_71, [
                  _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-total-split" })
                ]),
                (_ctx.results.categoryResults)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_72, _toDisplayString(this.calculateUpstreamTotal ===0? '0,00' :_ctx.doPrettify(this.calculateUpstreamTotal, 2)), 1))
                  : _createCommentVNode("", true),
                (_ctx.results.categoryResults)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_73, _toDisplayString(this.calculateDownstreamTotal ===0? '0,00' :_ctx.doPrettify(this.calculateDownstreamTotal, 2)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("tr", _hoisted_74, [
                _createElementVNode("td", _hoisted_75, [
                  _createVNode(_component_SimpleText, { "text-key": "results.scope3.result-grand-total" })
                ]),
                _hoisted_76,
                (_ctx.results.categoryResults)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_77, _toDisplayString(this.calculateDownstreamTotal + this.calculateUpstreamTotal ===0? '0,00' :_ctx.doPrettify(this.calculateDownstreamTotal + this.calculateUpstreamTotal, 2)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}